export type ColorTypes =
  | "accent-1"
  | "accent-2"
  | "accent-3"
  | "accent-4"
  | "accent-5"
  | "accent-6"
  | "accent-7"
  | "accent-8"
  | "accent-9"
  | "accent-10"
  | "accent-11"
  | "accent-12"
  | "accent-contrast"
  | "gray-1"
  | "gray-2"
  | "gray-3"
  | "gray-4"
  | "gray-5"
  | "gray-6"
  | "gray-7"
  | "gray-8"
  | "gray-9"
  | "gray-10"
  | "gray-11"
  | "gray-12"
  | "gray-contrast"
  | "green-weak"
  | "green-medium"
  | "green-strong"
  | "red-weak"
  | "red-medium"
  | "red-strong"
  | "yellow-strong"
  | "white-20"
  | "icon-secondary"
  | "black-a9"
  | "yellow-strong-2";

export const getColor = (color: ColorTypes) => `var(--${color})`;
